import React, {useState, useEffect, useContext, useRef} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import Select from 'react-select';
import { abilityOptions, rankOptions,
  // fieldOptions, freshOptions,  tagOptions, lookOptions ,
  interestOptions, SMjobOptions,  languageOptions, schoolOptions, majorOptions, degreeOptions, companyOptions, paperOptions, yearOptions, monthOptions } from '../SignIn/data';
import CreatableSelect from 'react-select/creatable';


function ResumeSingle(){
  const [state, actions] = useContext(UserContext);
  // const [ra, setRa] = useState(null)
  // const [singleApply, setSingleApply] = useState()
  const [singleResume, setSingleResume] = useState()
  const [basicdata, setBasicdata] = useState()
  const [school, setSchool] = useState()
  const [work, setWork] = useState()
  const [paperPaper, setPaperPaper] = useState()

  const inputFile = useRef(null) 
  const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);

  const [imgurl, setImgurl] = useState()

  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}
  
  const [activate, setActivate] = useState({
    "retitle": null,
    "intro": null,
    "field": null,
    "tools": null,
    "abilities": null,
    "interests": null,
    "tag": null,
    // "field": null,
    "job": null,
    "fresh": null,
    "wholeWork": null,
    "languages": null,
    "awards": null,
    "patents": null,
    "strength": null,
    "domain": null,

    "school": null,
    "work": null,
    "paperPaper": null

  })
  
  // console.log(history.location.pathname.split('/')[2])
  const current_id = history.location.pathname.split('/')[3]
  

  // resume
  const [retitle, setRetitle] = useState()
  const [intro, setIntro] = useState()
  const [strength, setStrength] = useState()
  const [wholeWork, setWholeWork] = useState()
  const [languages, setLanguages] = useState([])
  
  const [awards, setAwards] = useState([])
  const [tempawards, setTempwards] = useState([])
  const [patents, setPatents] = useState([])
  const [temppatents, setTemppatents] = useState([])

  const [abilities, setAbilities] = useState([])
  const [interests, setInterests] = useState([])
  const [tag, setTag] = useState([])
  const [domain, setDomain] = useState([])

  // school
  const [edit, setEdit] = useState()
  const [title, setTitle] = useState()
  const [major, setMajor] = useState()
  const [degree, setDegree] = useState()
  const [prof, setProf] = useState()
  const [paper, setPaper] = useState()
  const [startY, setStartY] = useState()
  const [startM, setStartM] = useState()
  const [endY, setEndY] = useState()
  const [endM, setEndM] = useState()

  // work
  // const [workEdit, setWorkEdit] = useState()
  const [workTitle, setWorkTitle] = useState()
  const [workJob, setWorkJob] = useState()
  const [workDepart, setWorkDepart] = useState()
  const [workStartY, setWorkStartY] = useState()
  const [workStartM, setWorkStartM] = useState()
  const [workEndY, setWorkEndY] = useState()
  const [workEndM, setWorkEndM] = useState()
  const [workMemo, setWorkMemo] = useState()
  const [workYoN, setWorkYoN] = useState(false)

  // paper
  const [paperTitle, setPaperTitle] = useState()
  const [paperJournal, setPaperJournal] = useState()
  const [paperAuthur, setPaperAuthur] = useState()
  // const [paperCoAuthur, setPaperCoAuthur] = useState()
  const [paperYear, setPaperYear] = useState()
  const [status, setStatus] = useState()

  useEffect(()=>{

    async function fetchBasicData(){
      fetch(state.awslink + "/user/userIntAbi/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setBasicdata(json)
        setImgurl(json.profilelink)
      })
    }
    
    async function fetchResumeSingleData(){
      fetch(state.awslink + "/api/resume/?id=" + current_id, {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        
        setSingleResume(json)

        setRetitle(json.title)

        setStrength(json.strength)
        setIntro(json.intro)
        setWholeWork(json.wholeWork)
        
        setAbilities(json.abilities)
        setInterests(json.interests)
        setTag(json.tag)
        setDomain(json.domain)
        setLanguages(json.languages)
        
        setAwards(json.awards)
        setPatents(json.patents)

      })
    }
    
    async function fetchResumeBasicData(){
      fetch(state.awslink + "/api/resume/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        let basic = json.filter(item=>item.title==="기본")[json.filter(item=>item.title==="기본").length-1]
        
        // setSingleResume(basic)

        // setRetitle(basic.title)

        // setStrength(basic.strength)
        // setIntro(basic.intro)
        setWholeWork(basic.wholeWork)
        
        setAbilities(basic.abilities)
        setInterests(basic.interests)
        
        setTag(basic.tag)
        setDomain(basic.domain)
        setLanguages(basic.languages)
        
        setAwards(basic.awards)
        setTempwards(basic.awards)
        
        setPatents(basic.patents)
        setTemppatents(basic.patents)

      })
    }

    async function fetchSchoolData(){
      fetch(state.awslink + "/user/school/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // console.log(json)
        setSchool(json)
      })
    }

    async function fetchWorkData(){
      fetch(state.awslink + "/user/work/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{setWork(json)})
    }

    async function fetchPaperData(){
      fetch(state.awslink + "/api/paper/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        setPaperPaper(json)
      })  
    }

    if(current_id === "add"){
      console.log("ADD")
      fetchResumeBasicData()
    }
    else{
      fetchResumeSingleData()
      
    }

    fetchSchoolData()
    fetchWorkData()
    fetchPaperData()
    fetchBasicData()

  },[])


  function fetchResumePost(){
    if(!singleResume){
      fetch(state.awslink + "/api/resume/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": retitle || null,
          "intro": intro || null,
          "abilities": abilities || null,
          "interests": interests || null,
          "tag": tag || null,
          "domain": domain || null,
          "wholeWork": wholeWork || null,
          "languages": languages || null,
          // "awards": tempawards && tempawards.length ? [tempawards] : null,
          // "patents": temppatents && temppatents.length ? [temppatents] : null,
          "awards": tempawards && tempawards.length ? tempawards : null,
          "patents": temppatents && temppatents.length ? temppatents : null,
          "strength": strength || null
        })
        })
        .then(response => response.json())
        .then(json=>{
          console.log(json)
          // history.push('/resume')
          setSingleResume(json)
        })
    }
    else{
      // console.log(singleResume)
      fetch(state.awslink + "/api/resume/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": singleResume.id,
          "title": retitle || null,
          "intro": intro || null,
          "abilities": abilities || null,
          "interests": interests || null,
          "tag": tag || null,
          "domain": domain || null,
          "wholeWork": wholeWork || null,
          "languages": languages || null,
          "awards": tempawards && tempawards.length ? [tempawards] : null,
          "patents": temppatents && temppatents.length ? [temppatents] : null,
          "strength": strength || null,
        })
        })
        .then(response => response.json())
        .then(json=>{
          console.log(json)
          setSingleResume(json)
          // history.push('/resume')
        })
    }
  }

  function fetchSchoolPost(){
    
    if(edit) {
      fetch(state.awslink + "/user/school/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": edit.id,
          "title": title || edit.title,
          "major": major || edit.major,
          "degree": degree || edit.degree,
          "prof": prof || edit.prof || null ,
          "paper": paper || edit.paper,
          "start": edit.start ? edit.start : (startY + "/" + startM),
          "end": edit.end ? edit.end : (endY + "/" + endM),
        })
      })
      .then(response => response.json())
      .then(json=>{
        let edited = school.filter((item)=> item.id === edit.id)
        // console.log(edited)
        edited[0].title = title || edit.title
        edited[0].major = major || edit.major
        edited[0].degree = degree || edit.degree
        edited[0].prof = prof || edit.prof
        edited[0].paper = paper || edit.paper
        edited[0].start = edit.start ? edit.start : (startY + "/" + startM)
        edited[0].end = edit.end ? edit.end : (endY + "/" + endM)

        // console.log(school)
        // setSchool(school)
        setSchool(json)
        setEdit();
      })
    }
    else {
      fetch(state.awslink + "/user/school/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": title,
          "major": major,
          "degree": degree,
          "prof": prof || null,
          "paper": paper,
          "start": startY + "/" + startM,
          "end": endY + "/" + endM,
        })
      })
      .then(response => response.json())
      .then(json=>{
        setSchool(oldArray => [...oldArray, {
          "title": title,
          "major": major,
          "degree": degree,
          "prof": prof || null,
          "paper": paper,
          "start": startY + "/" + startM,
          "end": endY + "/" + endM,
        }])

        // console.log(school)
        setSchool(json)
        setEdit();

      })
    }
  }

  function fetchWorkPost(){

    console.log(workTitle, workDepart, workMemo)
    console.log(edit)
    if(edit) {
      fetch(state.awslink + "/user/work/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": edit.id,
          "title": workTitle || edit.title,
          "job": workJob || edit.job,
          "depart": workDepart || edit.depart,
          "memo": workMemo || edit.memo,
          "start": edit.start ? edit.start : (workStartY + "/" + workStartM),
          "end": edit.end ? edit.end : (workEndY + "/" + workEndM) || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        let edited = work.filter((item)=> item.id === edit.id)
        // console.log(edited)
        edited[0].title = workTitle || edit.title
        edited[0].job = workJob || edit.job
        edited[0].depart = workDepart || edit.depart
        edited[0].memo = workMemo || edit.memo
        edited[0].start = edit.start ? edit.start : (workStartY + "/" + workStartM)
        edited[0].end = edit.end ? edit.end : (workEndY + "/" + workEndM)
        
        setWork(json)
        setEdit();
      })
    }
    else {
      fetch(state.awslink + "/user/work/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": workTitle,
          "job": workJob,
          "depart": workDepart || null,
          "memo": workMemo || null,
          "start": workStartY + "/" + workStartM,
          "end": workEndY + "/" + workEndM || null,
        })
      })
      .then(response => response.json())
      .then(json=>{
        setWork(oldArray => [...oldArray, {
          "title": workTitle,
          "job": workJob,
          "depart": workDepart || null,
          "memo": workMemo,
          "start": workStartY + "/" + workStartM,
          "end": workEndY + "/" + workEndM || null,
        }])

        // console.log(work)
        setWork(json)
        setEdit();

      })
    }
  }

  function fetchPaperPost(){
    
    if(edit) {
      fetch(state.awslink + "/api/paper/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": edit.id,
          "paperTitle": paperTitle || edit.paperTitle,
          "paperJournal": paperJournal || edit.paperJournal,
          "paperAuthur": paperAuthur || edit.paperAuthur,
          // "paperCoAuthur": paperCoAuthur || edit.paperCoAuthur,
          "paperCoAuthur": null,
          "paperYear": paperYear || edit.paperYear,
          "status": status || edit.status,
        })
      })
      .then(response => response.json())
      .then(json=>{
        let edited = paperPaper.filter((item)=> item.id === edit.id)
        // console.log(edited)
        edited[0].paperTitle = paperTitle || edit.paperTitle
        edited[0].paperJournal = paperJournal || edit.paperJournal
        edited[0].paperAuthur = paperAuthur || edit.paperAuthur
        // edited[0].paperCoAuthur = paperCoAuthur || edit.paperCoAuthur
        edited[0].paperCoAuthur = null
        edited[0].paperYear = paperYear || edit.paperYear
        edited[0].status = status || edit.statu
        

        // console.log(school)
        // setSchool(school)
        setPaperPaper(json)
        setEdit();
      })
    }
    else {
      fetch(state.awslink + "/api/paper/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "paperTitle": paperTitle,
          "paperJournal": paperJournal,
          "paperAuthur": paperAuthur,
          // "paperCoAuthur": paperCoAuthur,
          "paperCoAuthur": null,
          "paperYear": paperYear,
          "status": status,
        })
      })
      .then(response => response.json())
      .then(json=>{
        setPaperPaper(oldArray => [...oldArray, {
          "paperTitle": paperTitle,
          "paperJournal": paperJournal,
          "paperAuthur": paperAuthur,
          // "paperCoAuthur": paperCoAuthur,
          "paperCoAuthur": null,
          "paperYear": paperYear,
          "status": status,
        }])

        // console.log(school)
        setPaperPaper(json)
        setEdit();

      })
    }
  }

  function fetchResumeDelete(id, index, which){
    let awardsBool = false
    let patentsBool = false

    if(which === "awards")  awardsBool=true
    else                    patentsBool = true

    fetch(state.awslink + "/api/resume/", {
      method: 'DELETE',
      headers: header,
      body:JSON.stringify({
        "id": id,
        "awards": awardsBool,
        "patents": patentsBool,
        "index": index
      })
    })
    .then(response => response.json())
    .then(json=>{
      setSingleResume(json)
    })
  }

  function activateObj(index){
    let tempObj = {}
    for (const [key, value] of Object.entries(activate)) {
      if(index === "null") tempObj[`${key}`] = null
      else if(key === index) tempObj[`${key}`] = true
      else tempObj[`${key}`] = false
    }
    setActivate(tempObj)
  }

  const handleChange = (func) => e => {
    console.log(func)
    func(Array.isArray(e) ? e.map(x => x.value) : [])
  }

  function handleDefault(index) {
    let tempObj=[];
    if(index)
      index.map((item)=>{
        tempObj.push({value:item, label:item})
        return null
      })
    return(tempObj)
  }

  const handleChangeArr = (func, val, check) =>{
    if(check)
      func(oldArray => [...oldArray, val])
    else
      func([val])

    return val
  }

  const changeHandler = (event, whichimg) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
    console.log("changeHandler")
    handleSubmission(event.target.files[0], whichimg)

	};

  const handleSubmission = (file, whichimg) => {
    console.log("handleSubmission")
    console.log(file)
		const formData = new FormData();
    formData.append('file', file,  whichimg + '.' + file.name.split('.')[file.name.split('.').length-1]);
    
		fetch(
			state.awslink + "/api/file/?" + whichimg + "=true",
			{
				method: 'POST',
        headers: header,
				body: formData,
			}
		)
			.then((response) => response.json())
			.then((result) => {
				console.log('Success:', result);

        setIsFilePicked()
			})
			.catch((error) => {
				console.error('Error:', error);
			});
    
	};

  const onButtonClick = (whichimg) => {
    inputFile.current.click();
  };

  function yearSelectorStart(yset, mset, y, m){
    return(
      <YearWrapper>
        <Select
          className="profile-basic-date"
          defaultValue={edit? {value: edit.start.split('/')[0], label: edit.start.split('/')[0]}: null}
          isSearchable={true}
          name="color"
          options={yearOptions}
          onChange={(e)=>{
            if(e.value) yset(e.value)
            if(edit) edit.start = e.value + '/' + (edit.start.split('/')[1] || m)
          }}
        />
        <Select
          className="profile-basic-date-month"
          defaultValue={edit? {value: edit.start.split('/')[1], label: edit.start.split('/')[1]}: null}
          isSearchable={true}
          name="color"
          options={monthOptions}
          onChange={(e)=>{
            if(e.value) mset(e.value);
            if(edit) edit.start = (edit.start.split('/')[0] || y) + '/' + e.value
          }}
        />
      </YearWrapper>
      )
    }  

  function yearSelectorEnd(yset, mset, y, m){
    return(
      <YearWrapper>
        <Select
          className="profile-basic-date"
          defaultValue={edit? {value: edit.end.split('/')[0], label: edit.end.split('/')[0]}: null}
          isSearchable={true}
          name="color"
          options={yearOptions}
          onChange={(e)=>{
            if(e.value) yset(e.value)
            if(edit) edit.end = e.value + '/' + (edit.end.split('/')[1] || m)
          }}
        />
        <Select
          className="profile-basic-date-month"
          defaultValue={edit? {value: edit.end.split('/')[1], label: edit.end.split('/')[1]}: null}
          isSearchable={true}
          name="color"
          options={monthOptions}
          onChange={(e)=>{
            if(e.value) mset(e.value);
            if(edit) edit.end = (edit.end.split('/')[0] || y) + '/' + e.value 
          }}
        />
      </YearWrapper>
      )
    }  
  // console.log(singleResume)
  // console.log(awards, patents)

  return(
    <>
    {state.width < state.breakpoint ? 
      null
      :
      <Wrapper>
        <MidWrapper>
          <RaWrapper>
            {current_id !== "add" ? 
            
            singleResume && school && work && paperPaper && basicdata && 
            <>
              <ImgWrapper>
                <img 
                  src = {imgurl? imgurl + "?dummy=123123" : "dummy"} 
                  onError={(e)=> {
                    // console.log(e.target.src.split('.')[e.target.src.split('.').length-1] )
                    // if(e.target.src.split('.')[e.target.src.split('.').length-1] === 'png'){
                    //   console.log("png error")
                    //   e.target.src = state.s3link + "/images/" + email + '/profile.jpg'
                    // }else if(e.target.src.split('.')[e.target.src.split('.').length-1] === 'jpg'){
                    //   console.log("jpg error")
                    //   e.target.src = state.s3link + "/images/" + email + '/profile.jpeg'
                    // }
                    // else{
                    //   console.log("jpeg error")
                      e.target.src = state.noimage
                    // }
                  }}
                  alt='profile'
                  onClick={()=>onButtonClick("profile")}
                  style={{cursor: "pointer" }}
                />
                <input 
                  type="file" 
                  name="file" 
                  ref={inputFile} 
                  onChange={(e)=>{changeHandler(e, "profile"); console.log("onChange")}} 
                  style={{ display: "none" }}/>
                <div className={"name"}>{basicdata.realname}</div>
                <div >{basicdata.realphone}</div>
                <div>{basicdata.realmail}</div>

              </ImgWrapper>
              
              <div className="devider"></div>

              {/* Title */}
              <span className={activate.retitle===false ? "deactivate": "activate"}>
                <h4>제목</h4>
                <WriteEditForm>
                  {retitle ?
                    <>
                      <div className="ras-text">
                        {activate.retitle ? null : <> {retitle} </>}
                      </div>
                      {activate.retitle ? null : 
                      <button onClick={()=>activateObj("retitle")}>
                        <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button> }
                    </>
                    : activate.retitle ? null : <button onClick={()=>activateObj("retitle")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                  }
                </WriteEditForm>
                
                {activate.retitle?
                <AfterForm>
                  <input className="profile-basic-input" value={retitle} onChange={(e)=>setRetitle(e.target.value)}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setRetitle(retitle)}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Strength */}
              <span className={activate.strength===false ? "deactivate": "activate"}>
                <h4>특장점</h4>
                {/* <WriteEditForm> */}
                {strength ?
                  <> 
                    {activate.strength ? null : 
                    <WriteEditForm> 
                      <div className="ras-text">
                        <p>{strength}</p>
                      </div> 
                      <button onClick={()=>activateObj("strength")}>
                      <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button> 
                    </WriteEditForm>}
                  </>
                  : activate.strength ? null : 
                    <WriteEditForm>
                    <button onClick={()=>activateObj("strength")}>
                      <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                    </button>
                    </WriteEditForm>
                }
                {/* </WriteEditForm> */}
                
                {activate.strength?
                <AfterForm>
                  <textarea className="profile-basic-ta" value={strength} onChange={(e)=>setStrength(e.target.value)}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setStrength(strength)}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>


              {/* Intro */}
              <span className={activate.intro===false ? "deactivate": "activate"}>
                <h4>자기소개</h4>
                <WriteEditForm>
                  {intro ?
                    <>
                      <div>
                        {activate.intro ? null : <> <p>{intro}</p>  </>}
                      </div>
                      {!activate.intro && <button onClick={()=>activateObj("intro")}>
                      <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                    </>
                    : activate.intro ? null : <button onClick={()=>activateObj("intro")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                  }
                </WriteEditForm>

                {activate.intro?
                <AfterForm>
                  <textarea className="profile-basic-ta" value={intro} onChange={(e)=>setIntro(e.target.value)}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setIntro(intro)}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              
              <div className="devider"></div>
              
              {/* Work */}
              <span className={activate.work===false ? "deactivate": "activate"}>
                <h4>경력사항</h4>
                {work.length ?
                  <SchoolForm className={"ras-work"}>
                    {work.map((item, index)=>{
                      // console.log(item); 
                      if(edit === item){
                        return (
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                직장이름
                                <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={companyOptions}
                                  onChange={(e)=>setWorkTitle(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>

                            <span>
                              <div>
                                부서
                                <input className="profile-basic-input" value={edit? edit.depart: workDepart} onChange={(e)=>{setWorkDepart(e.target.value); if(edit) edit.depart=e.target.value}}/>
                              </div>
                            </span>
                            
                            <span>
                              <div>
                                직급
                              <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.job, label: edit.job}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={rankOptions}
                                  onChange={(e)=>setWorkJob(e.value)}
                                />
                              </div>
                            </span>

                            {yearSelectorStart(setWorkStartY, setWorkStartM, workStartY, workStartM)}

                            <input type='checkbox' onChange={()=>setWorkYoN(!workYoN)}></input>

                            {workYoN? null:
                            yearSelectorEnd(setWorkEndY, setWorkEndM, workEndY, workEndM)
                            }
                            
                            
                            <span className="write-memo">
                              <div>
                                Memo
                                <textarea className="profile-basic-ta" value={edit? edit.memo : workMemo} onChange={(e)=>{setWorkMemo(e.target.value); if(edit) edit.memo = e.target.value}}/>
                              </div>
                            </span>

                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchWorkPost(); }}>저장</button>
                            </AfterBtnForm>
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                        )
                      } else{
                        return(
                        <div>
                          <h4>
                            {item.title}
                            {activate.work ? null : <button onClick={()=>{activateObj("work"); setEdit(item); console.log(item)}}>
                            <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                          </h4>

                          <div className={"qu-add"}>
                            {item.depart} / {item.job}
                          </div>
                          
                          <div className={"qu-add"}>
                            {item.start} ~ {item.end}
                          </div>
                          
                          <div className={"ras-work-memo"}>
                            <p>{item.memo}</p>
                          </div>
                          {/* {activate.work ? null : <button onClick={()=>{activateObj("work"); setEdit(item); console.log(item)}}>
                            수정하기</button>} */}
                        </div>)}})}

                    
                  </SchoolForm>
                  : <AddBtn onClick={()=>activateObj("work")}>추가하기</AddBtn>
                }

                {activate.work && !edit ?     
                  <SchoolEditForm>
                    <div className="sub-devider"></div>
                    <span>
                      <div>
                        직장이름
                        <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.title, label: edit.title}: null}
                          isSearchable={true}
                          name="color"
                          options={companyOptions}
                          onChange={(e)=>setWorkTitle(e.value)}
                          // onInputChange={arraySet(index, title)}
                            // setTitle(e.value)}}
                        />
                      </div>
                    </span>

                    <span>
                      <div>
                        부서
                        <input className="profile-basic-input" value={edit? edit.depart: workDepart} onChange={(e)=>{setWorkDepart(e.target.value); if(edit) edit.depart=e.target.value}}/>
                      </div>
                    </span>

                    <span>
                      <div>
                        직급
                      <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.job, label: edit.job}: null}
                          isSearchable={true}
                          name="color"
                          options={rankOptions}
                          onChange={(e)=>setWorkJob(e.value)}
                        />
                      </div>
                    </span>

                    {yearSelectorStart(setWorkStartY, setWorkStartM, workStartY, workStartM)}

                    <input type='checkbox' onChange={()=>setWorkYoN(!workYoN)}></input>

                    {workYoN? null:
                    yearSelectorEnd(setWorkEndY, setWorkEndM, workEndY, workEndM)
                    }
                    
                    
                    <span className="write-memo">
                      <div>
                        메모
                        <textarea className="profile-basic-ta" value={edit? edit.memo : workMemo} onChange={(e)=>{setWorkMemo(e.target.value); if(edit) edit.memo = e.target.value}}/>
                      </div>
                    </span>

                    <AfterBtnForm>
                      <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                      <button onClick={()=>{activateObj("null"); fetchWorkPost(); }}>임시저장</button>
                    </AfterBtnForm>
                    <div className="sub-devider"></div>
                  </SchoolEditForm>
                  :   
                  <>
                    <AddBtn onClick={()=>activateObj("work")}>추가하기</AddBtn>
                  </>
                }
                
              </span>
              
              <div className="devider"></div>
              
              {/* School */}
              <span className={activate.school===false ? "deactivate": "activate"}>
                <h4>학력사항</h4>
                {school.length ?
                  <SchoolForm className={"ras-work"}>
                    {school.map((item, index)=>{
                      // console.log(item); 
                      if(edit === item){
                        return (
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                학교이름
                                <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={schoolOptions}
                                  onChange={(e)=>setTitle(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>
                            <span>
                              <div>
                                전공
                              <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.major, label: edit.major}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={majorOptions}
                                  onChange={(e)=>setMajor(e.value)}
                                />
                              </div>
                            </span>
                                
                            <span>
                              <div>
                                학위
                                <Select
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.degree, label: edit.degree}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={degreeOptions}
                                  onChange={(e)=>{if(edit) {setDegree(e.value); edit.degree = e.value} else{setDegree(e.value)}}}
                                />
                              </div>
                            </span>
                                {degree === undefined && edit === undefined ? null : 
                                    edit ? 
                                      edit.degree==="학사 과정" || edit.degree==="학사 졸업" ?
                                      null: 
                                      <span>
                                        <div>
                                          지도교수
                                          <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                        </div>
                                      </span>  
                                    : 
                                    degree === "학사 과정" || degree === "학사 졸업" ?
                                    null
                                    :
                                    <span>
                                        <div>
                                          지도교수
                                          <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                        </div>
                                      </span>  
                                }

                                <span>
                                  <div>
                                    연구주제
                                  <input className="profile-basic-input" value={edit? edit.paper: paper} onChange={(e)=>{setPaper(e.target.value); if(edit) edit.paper=e.target.value}}/>
                                  </div>
                                </span>

                                {
                                  degree === undefined && edit === undefined ? null : 
                                    edit ? 
                                      edit.degree==="학사 과정" || edit.degree==="석사 과정" || edit.degree === "박사(통합) 과정" ?
                                        <>
                                          {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                        </>
                                        :
                                        <>
                                          {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                          {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                        </>
                                      :
                                      degree==="학사 과정" || degree==="석사 과정" || degree === "박사(통합) 과정"?
                                      <>
                                        {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                      </>
                                      :
                                      <>
                                        {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                        {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                      </>
                                }
                                
                            <AfterBtnForm>
                            {/* <button onClick={()=>{activateObj("null"); setTitle(); setMajor(); setPaper(); setDegree(); setProf(); setStartY(); setStartM(); setEndY(); setEndM(); setEdit()}}>취소</button> */}
                            <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                            <button onClick={()=>{activateObj("null"); fetchSchoolPost(); }}>저장</button>
                            </AfterBtnForm>
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                        )
                      } else{
                        return(
                        <div>
                          <h4>
                            {item.title}
                            {activate.school ? null : <button onClick={()=>{activateObj("school"); setEdit(item); console.log(item)}}>
                            <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                          </h4>

                          <div className={"qu-add"}>
                            {item.major}
                          </div>

                          <div className={"qu-add"}>
                            {item.degree} 
                            {item.degree === "박사(통합) 과정" || item.degree === "박사(통합) 졸업" || item.degree === "석사 과정" || item.degree === "석사 졸업"
                            ? " / " + item.prof: null}
                          </div>

                          <div className={"qu-add"}>
                            {item.start}
                            {item.end !== "undefined/undefined" 
                            && " - " + item.end}
                          </div>

                          {/* EditorState? */}
                          <div className={"ras-work-memo"}>
                            <p>{item.paper}</p>
                          </div>

                          
                        </div>
                        )}})}

                    
                  </SchoolForm>
                  : <AddBtn onClick={()=>activateObj("school")}>추가하기</AddBtn>
                }

                {activate.school && edit === undefined ? 
                  <SchoolEditForm>
                    <div className="sub-devider"></div>
                    <span>
                      <div>
                        학교이름
                        <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.title, label: edit.title}: null}
                          isSearchable={true}
                          name="color"
                          options={schoolOptions}
                          onChange={(e)=>setTitle(e.value)}
                          // onInputChange={arraySet(index, title)}
                            // setTitle(e.value)}}
                        />
                      </div>
                    </span>
                    <span>
                      <div>
                        전공
                      <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.major, label: edit.major}: null}
                          isSearchable={true}
                          name="color"
                          options={majorOptions}
                          onChange={(e)=>setMajor(e.value)}
                        />
                      </div>
                    </span>
                        
                    <span>
                      <div>
                        학위
                        <Select
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.degree, label: edit.degree}: null}
                          isSearchable={true}
                          name="color"
                          options={degreeOptions}
                          onChange={(e)=>{if(edit) {setDegree(e.value); edit.degree = e.value} else{setDegree(e.value)}}}
                        />
                      </div>
                    </span>
                        {degree === undefined && edit === undefined ? null : 
                            edit ? 
                              edit.degree==="학사 과정" || edit.degree==="학사 졸업" ?
                              null: 
                              <span>
                                <div>
                                  지도교수
                                  <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>  
                            : 
                            degree === "학사 과정" || degree === "학사 졸업" ?
                            null
                            :
                            <span>
                                <div>
                                  지도교수
                                  <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>  
                        }

                        <span>
                          <div>
                            연구주제
                          <input className="profile-basic-input" value={edit? edit.paper: paper} onChange={(e)=>{setPaper(e.target.value); if(edit) edit.paper=e.target.value}}/>
                          </div>
                        </span>

                        {
                          degree === undefined && edit === undefined ? null : 
                            edit ? 
                              edit.degree==="학사 과정" || edit.degree==="석사 과정" || edit.degree === "박사(통합) 과정" ?
                              <>
                                {yearSelectorStart(setStartY, setStartM, startY, startM)}
                              </>
                              :
                              <>
                                {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                              </>
                              :
                              degree==="학사 과정" || degree==="석사 과정" || degree === "박사(통합) 과정"?
                              <>
                                {yearSelectorStart(setStartY, setStartM, startY, startM)}
                              </>
                              :
                              <>
                                {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                              </>
                        }
                        
                    <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchSchoolPost(); }}>저장</button>
                    </AfterBtnForm>
                    <div className="sub-devider"></div>
                  </SchoolEditForm>
                  :   
                <>
                  <AddBtn onClick={()=>activateObj("school")}>추가하기</AddBtn>
                </>
                // null
                }
                
              </span>
              
              <div className="devider"></div>
              
              {/* Abilities */}
              <span className={activate.abilities===false ? "deactivate": "activate"}>
                <h4>기술/도구</h4>
                <WriteEditForm>
                {abilities && abilities.length ?
                  <>

                    {abilities.map((item)=>{
                      return(
                        <div className="ras-tag">{item}</div>
                      )
                    })}
                    {activate.abilities ? null : <button onClick={()=>activateObj("abilities")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                  </>
                  : activate.abilities ? null : <button onClick={()=>activateObj("abilities")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                }
                </WriteEditForm>
                {activate.abilities?
                <AfterForm>
                  <CreatableSelect
                    defaultValue={handleDefault(abilities)}
                    className="profile-basic-multi"
                    isMulti
                    options={abilityOptions}
                    onChange={handleChange(setAbilities)}
                  />
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setAbilities(abilities);}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Domain */}
              <span className={activate.domain===false ? "deactivate": "activate"}>
                <h4>도메인</h4>
                <WriteEditForm>
                {domain && domain.length ?
                  <>
                    {domain.map((item)=>{
                      return(
                        <div className="ras-tag">{item}</div>
                      )
                    })}
                    {activate.domain ? null : <button onClick={()=>activateObj("domain")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                  </>
                  : activate.domain ? null : <button onClick={()=>activateObj("domain")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                  </button>
                }
                </WriteEditForm>
                
                {activate.domain?
                <AfterForm>
                  <CreatableSelect
                    defaultValue={handleDefault(domain)}
                    className="profile-basic-multi"
                    isMulti
                    options={interestOptions}
                    onChange={handleChange(setDomain)}
                  />
                  <AfterBtnForm>
                  <button onClick={()=>{activateObj("null"); setDomain(domain);}}>취소</button>
                  <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Languages */}
              <span className={activate.languages===false ? "deactivate": "activate"}>
                <h4>언어</h4>
                <WriteEditForm>
                {languages.length ?
                  <>
                    {languages.map((item)=>{
                      return(
                        <div className="ras-tag">{item}</div>
                      )
                    })}
                    {activate.languages ? null : <button onClick={()=>activateObj("languages")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                  </>
                  : activate.languages ? null : <button onClick={()=>activateObj("languages")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                  </button>
                }
                </WriteEditForm>
                {activate.languages?
                <AfterForm>
                  <Select
                    defaultValue={handleDefault(languages)}
                    className="profile-basic-multi"
                    isMulti
                    options={languageOptions}
                    onChange={handleChange(setLanguages)}
                  />
                  <AfterBtnForm>
                  <button onClick={()=>{activateObj("null"); setLanguages(languages);}}>취소</button>
                  <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Awards */}
              <span className={activate.awards===false ? "deactivate": "activate"}>
                <h4>수상</h4>
                <WriteEditForm>
                  {singleResume.awards ?
                    <>
                      <div className="ras-li">
                        {singleResume.awards.map((item, index)=>{
                          return(
                            <>
                              <div>
                                {item}
                                <button 
                                onClick={()=>{
                                  fetchResumeDelete(singleResume.id, index, "awards")
                                }
                                }>X</button>
                              </div>
                              
                              </>
                          )
                        })}
                      </div>
                    </>
                    : 
                    awards? 
                      <div className="ras-li">
                          {awards.map((item)=>{
                            return(
                              <div>
                                {item}
                              </div>
                            )
                          })}
                        </div>
                        :null
                  }
                  
                </WriteEditForm>
                {activate.awards?
                <AfterForm>
                  <input className="profile-basic-input" value={tempawards} onChange={(e)=>{setTempwards(e.target.value)}}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null");}}>취소</button>
                    <button onClick={()=>{activateObj("null"); handleChangeArr(setAwards, tempawards, awards); 
                    // if(resume.length) 
                        setTempwards(); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :
                <>
                  <AddBtn onClick={()=>activateObj("awards")}>추가하기</AddBtn>
                </>
                }
                  
              </span>

              {/* Patents */}
              <span className={activate.patents===false ? "deactivate": "activate"}>
                <h4>특허</h4>
                <WriteEditForm>
                  {singleResume.patents ?
                    <>
                      <div className="ras-li">
                        {singleResume.patents.map((item, index)=>{
                          return(
                            <>
                            <div>
                              {item}
                              <button 
                              onClick={()=>{
                                fetchResumeDelete(singleResume.id, index, "patents")
                              }
                              }>X</button>
                            </div>
                            
                            </>
                          )
                        })}
                      </div>
                    </>
                    : 
                    patents? 
                      <div className="ras-li">
                          {patents.map((item)=>{
                            return(
                              <div>
                                {item}
                              </div>
                            )
                          })}
                        </div>
                        :null
                  }
                  
                </WriteEditForm>
                {activate.patents?
                <AfterForm>
                  <input className="profile-basic-input" value={temppatents} onChange={(e)=>{setTemppatents(e.target.value)}}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null");}}>취소</button>
                    <button onClick={()=>{activateObj("null"); handleChangeArr(setPatents, temppatents, patents); 
                    // if(resume.length) 
                    setTemppatents(); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :
                <>
                  <AddBtn onClick={()=>activateObj("patents")}>추가하기</AddBtn>
                </>
                }
                  
              </span>
              
              {/* Paper */}
              <span className={activate.paperPaper===false ? "deactivate": "activate"}>
                <h4>논문</h4>
                {paperPaper.length ?
                  <SchoolForm className={"ras-work"}>
                    {paperPaper.map((item, index)=>{
                      // console.log(item); 
                      if(edit === item){
                        return (
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                제목
                                <input className="profile-basic-input" value={edit? edit.paperTitle: paperTitle} onChange={(e)=>{setPaperTitle(e.target.value); if(edit) edit.paperTitle=e.target.value}}/>
                              </div>
                            </span>
                            
                            <span>
                              <div>
                                저널
                                <input className="profile-basic-input" value={edit? edit.paperJournal: paperJournal} onChange={(e)=>{setPaperJournal(e.target.value); if(edit) edit.paperJournal=e.target.value}}/>
                              </div>
                            </span>
                                
                            <span>
                              <div>
                                저자
                                <input className="profile-basic-input" value={edit? edit.paperAuthur: paperAuthur} onChange={(e)=>{setPaperAuthur(e.target.value); if(edit) edit.paperAuthur=e.target.value}}/>
                              </div>
                            </span>
                              {/* <span>
                                <div>
                                  공저자
                                <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>   */}
                              
                              
                              {/* <span>
                                <div>
                                  년도
                                <input className="profile-basic-input" value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>
                                </div>
                              </span> */}
                              
                            <span>
                              <div>
                                상태
                                <Select
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.status, label: edit.status}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={paperOptions}
                                  onChange={(e)=>setStatus(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>
                            
                            {/* {yearSelectorStart()} */}
                            <YearWrapper>
                              <input className="profile-basic-input" style={{width: 80}} value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>년 
                            </YearWrapper>

                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchPaperPost();  }}>저장</button>
                            </AfterBtnForm>
                              
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                        )
                      } else{
                        return(
                        <div>
                          <h4 style={{fontSize: ".9rem"}}>
                            {item.paperTitle}
                            {activate.paperPaper ? null : <button onClick={()=>{activateObj("paperPaper"); setEdit(item); console.log(item)}}>
                            <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                          </h4>
                          <div className="qu-add"> {item.paperJournal} {item.paperAuthur} {item.paperCoAuthur} {item.paperYear} {item.status}</div>
                          <div className="ras-work-memo"></div>
                        </div>)}})}

                    {activate.paperPaper ? null :   
                    <>
                      <AddBtn onClick={()=>activateObj("paperPaper")}>추가하기</AddBtn>
                    </>
                    }
                  </SchoolForm>
                  : <AddBtn onClick={()=>activateObj("paperPaper")}>추가하기</AddBtn>
                }
                
                {activate.paperPaper && !edit?
                <SchoolEditForm>
                  <div className="sub-devider"></div>
                  <span>
                    <div>
                      제목
                      <input className="profile-basic-input" value={edit? edit.paperTitle: paperTitle} onChange={(e)=>{setPaperTitle(e.target.value); if(edit) edit.paperTitle=e.target.value}}/>
                    </div>
                  </span>
                  
                  <span>
                    <div>
                      저널
                      <input className="profile-basic-input" value={edit? edit.paperJournal: paperJournal} onChange={(e)=>{setPaperJournal(e.target.value); if(edit) edit.paperJournal=e.target.value}}/>
                    </div>
                  </span>
                      
                  <span>
                    <div>
                      저자
                      <input className="profile-basic-input" value={edit? edit.paperAuthur: paperAuthur} onChange={(e)=>{setPaperAuthur(e.target.value); if(edit) edit.paperAuthur=e.target.value}}/>
                    </div>
                  </span>
                    
                  <span>
                    <div>
                      상태
                      <Select
                        className="profile-basic-single"
                        defaultValue={edit? {value: edit.status, label: edit.status}: null}
                        isSearchable={true}
                        name="color"
                        options={paperOptions}
                        onChange={(e)=>setStatus(e.value)}
                      />
                    </div>
                  </span>
                  
                  <YearWrapper>
                    <input className="profile-basic-input" style={{width: 80}} value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>년 
                  </YearWrapper>

                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchPaperPost();  }}>저장</button>
                  </AfterBtnForm>
                    
                  <div className="sub-devider"></div>
                </SchoolEditForm>
                :null
                }
              </span>
              
            </>
              
            :
            school && work && paperPaper && basicdata && 
            <>

              <ImgWrapper>
                <img 
                  src = {state.s3link + "/images/" + email + '/profile.png'} 
                  onError={(e)=> {
                    console.log(e.target.src.split('.')[e.target.src.split('.').length-1] )
                    if(e.target.src.split('.')[e.target.src.split('.').length-1] === 'png'){
                      console.log("png error")
                      e.target.src = state.s3link + "/images/" + email + '/profile.jpg'
                    }else if(e.target.src.split('.')[e.target.src.split('.').length-1] === 'jpg'){
                      console.log("jpg error")
                      e.target.src = state.s3link + "/images/" + email + '/profile.jpeg'
                    }
                    else{
                      console.log("jpeg error")
                      e.target.src = state.noimage
                    }
                  }}
                  onClick={()=>onButtonClick("profile")}
                  style={{cursor: "pointer" }}
                />
                <input 
                  type="file" 
                  name="file" 
                  ref={inputFile} 
                  onChange={(e)=>{changeHandler(e, "profile"); console.log("onChange")}} 
                  style={{ display: "none" }}/>
                <div className={"name"}>{basicdata.realname}</div>
                <div >{basicdata.realphone}</div>
                <div>{basicdata.realmail}</div>

              </ImgWrapper>
              
              <div className="devider"></div>

              {/* Title */}
              <span className={activate.retitle===false ? "deactivate": "activate"}>
                <h4>제목</h4>
                <WriteEditForm>
                  {retitle ?
                    <>
                      <div className="ras-text">
                        {activate.retitle ? null : <> {retitle} </>}
                      </div>
                      {activate.retitle ? null : 
                      <button onClick={()=>activateObj("retitle")}>
                        <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button> }
                    </>
                    : activate.retitle ? null : <button onClick={()=>activateObj("retitle")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                  }
                </WriteEditForm>
                
                {activate.retitle?
                <AfterForm>
                  <input className="profile-basic-input" value={retitle} onChange={(e)=>setRetitle(e.target.value)}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setRetitle(retitle)}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost() }}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Strength */}
              <span className={activate.strength===false ? "deactivate": "activate"}>
                <h4>특장점</h4>
                {/* <WriteEditForm> */}
                {strength ?
                  <> 
                    {activate.strength ? null : 
                    <WriteEditForm> <div className="ras-text">{strength}</div> <button onClick={()=>activateObj("strength")}>
                      <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button> 
                    </WriteEditForm>}
                  </>
                  : activate.strength ? null : 
                    <WriteEditForm>
                    <button onClick={()=>activateObj("strength")}>
                      <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                    </button>
                    </WriteEditForm>
                }
                {/* </WriteEditForm> */}
                
                {activate.strength?
                <AfterForm>
                  <textarea className="profile-basic-ta" value={strength} onChange={(e)=>setStrength(e.target.value)}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setStrength(strength)}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Intro */}
              <span className={activate.intro===false ? "deactivate": "activate"}>
                <h4>자기소개</h4>
                <WriteEditForm>
                  {intro ?
                    <>
                      <div>
                        {activate.intro ? null : <> {intro}  </>}
                      </div>
                      <button onClick={()=>activateObj("intro")}>
                      <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                    </>
                    : activate.intro ? null : <button onClick={()=>activateObj("intro")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                  }
                </WriteEditForm>

                {activate.intro?
                <AfterForm>
                  <textarea className="profile-basic-ta" value={intro} onChange={(e)=>setIntro(e.target.value)}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setIntro(intro)}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost() }}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              <div className="devider"></div>

              {/* Work */}
              <span className={activate.work===false ? "deactivate": "activate"}>
                <h4>직장</h4>
                {work.length ?
                  <SchoolForm className={"ras-work"}>
                    {work.map((item, index)=>{
                      // console.log(item); 
                      if(edit === item){
                        return (
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                직장이름
                                <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={companyOptions}
                                  onChange={(e)=>setWorkTitle(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>

                            <span>
                              <div>
                                부서
                                <input className="profile-basic-input" value={edit? edit.depart: workDepart} onChange={(e)=>{setWorkDepart(e.target.value); if(edit) edit.depart=e.target.value}}/>
                              </div>
                            </span>
                            
                            <span>
                              <div>
                                직급
                              <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.job, label: edit.job}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={rankOptions}
                                  onChange={(e)=>setWorkJob(e.value)}
                                />
                              </div>
                            </span>


                            {yearSelectorStart(setWorkStartY, setWorkStartM, workStartY, workStartM)}

                            <input type='checkbox' onChange={()=>setWorkYoN(!workYoN)}></input>

                            {workYoN? null:
                            yearSelectorEnd(setWorkEndY, setWorkEndM, workEndY, workEndM)
                            }
                            
                            
                            <span className="write-memo">
                              <div>
                                Memo
                                <textarea className="profile-basic-ta" value={edit? edit.memo : workMemo} onChange={(e)=>{setWorkMemo(e.target.value); if(edit) edit.memo = e.target.value}}/>
                              </div>
                            </span>

                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchWorkPost(); }}>저장</button>
                            </AfterBtnForm>
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                        )
                      } else{
                        return(
                        <div>
                          <h4>
                            {item.title}
                            {activate.work ? null : <button onClick={()=>{activateObj("work"); setEdit(item); console.log(item)}}>
                            <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                          </h4>

                          <div className={"qu-add"}>
                            {item.depart} / {item.job}
                          </div>
                          
                          <div className={"qu-add"}>
                            {item.start} ~ {item.end}
                          </div>
                          
                          <div className={"ras-work-memo"}>
                            <p>{item.memo}</p>
                          </div>
                          {/* {activate.work ? null : <button onClick={()=>{activateObj("work"); setEdit(item); console.log(item)}}>
                            수정하기</button>} */}
                        </div>)}})}

                    
                  </SchoolForm>
                  : <AddBtn onClick={()=>activateObj("work")}>추가하기</AddBtn>
                }

                {activate.work && !edit ?     
                  <SchoolEditForm>
                    <div className="sub-devider"></div>
                    <span>
                      <div>
                        직장이름
                        <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.title, label: edit.title}: null}
                          isSearchable={true}
                          name="color"
                          options={companyOptions}
                          onChange={(e)=>setWorkTitle(e.value)}
                          // onInputChange={arraySet(index, title)}
                            // setTitle(e.value)}}
                        />
                      </div>
                    </span>

                    <span>
                      <div>
                        부서
                        <input className="profile-basic-input" value={edit? edit.depart: workDepart} onChange={(e)=>{setWorkDepart(e.target.value); if(edit) edit.depart=e.target.value}}/>
                      </div>
                    </span>

                    <span>
                      <div>
                        직급
                      <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.job, label: edit.job}: null}
                          isSearchable={true}
                          name="color"
                          options={rankOptions}
                          onChange={(e)=>setWorkJob(e.value)}
                        />
                      </div>
                    </span>

                    
                    {yearSelectorStart(setWorkStartY, setWorkStartM, workStartY, workStartM)}

                    <input type='checkbox' onChange={()=>setWorkYoN(!workYoN)}></input>

                    {workYoN? null:
                    yearSelectorEnd(setWorkEndY, setWorkEndM, workEndY, workEndM)
                    }
                    
                    
                    <span className="write-memo">
                      <div>
                        메모
                        <textarea className="profile-basic-ta" value={edit? edit.memo : workMemo} onChange={(e)=>{setWorkMemo(e.target.value); if(edit) edit.memo = e.target.value}}/>
                      </div>
                    </span>

                    <AfterBtnForm>
                      <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                      <button onClick={()=>{activateObj("null"); fetchWorkPost(); }}>임시저장</button>
                    </AfterBtnForm>
                    <div className="sub-devider"></div>
                  </SchoolEditForm>
                  :   
                  <>
                    <AddBtn onClick={()=>activateObj("work")}>추가하기</AddBtn>
                  </>
                }
                
              </span>

              <div className="devider"></div>

              {/* School */}
              <span className={activate.school===false ? "deactivate": "activate"}>
                <h4>학력사항</h4>
                {school.length ?
                  <SchoolForm className={"ras-work"}>
                    {school.map((item, index)=>{
                      // console.log(item); 
                      if(edit === item){
                        return (
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                학교이름
                                <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.title, label: edit.title}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={schoolOptions}
                                  onChange={(e)=>setTitle(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>
                            <span>
                              <div>
                                전공
                              <CreatableSelect
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.major, label: edit.major}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={majorOptions}
                                  onChange={(e)=>setMajor(e.value)}
                                />
                              </div>
                            </span>
                                
                            <span>
                              <div>
                                학위
                                <Select
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.degree, label: edit.degree}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={degreeOptions}
                                  onChange={(e)=>{if(edit) {setDegree(e.value); edit.degree = e.value} else{setDegree(e.value)}}}
                                />
                              </div>
                            </span>
                                {degree === undefined && edit === undefined ? null : 
                                    edit ? 
                                      edit.degree==="학사 과정" || edit.degree==="학사 졸업" ?
                                      null: 
                                      <span>
                                        <div>
                                          지도교수
                                          <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                        </div>
                                      </span>  
                                    : 
                                    degree === "학사 과정" || degree === "학사 졸업" ?
                                    null
                                    :
                                    <span>
                                        <div>
                                          지도교수
                                          <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                        </div>
                                      </span>  
                                }

                                <span>
                                  <div>
                                    연구주제
                                  <input className="profile-basic-input" value={edit? edit.paper: paper} onChange={(e)=>{setPaper(e.target.value); if(edit) edit.paper=e.target.value}}/>
                                  </div>
                                </span>

                                {
                                  degree === undefined && edit === undefined ? null : 
                                    edit ? 
                                      edit.degree==="학사 과정" || edit.degree==="석사 과정" || edit.degree === "박사(통합) 과정" ?
                                        <>
                                          {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                        </>
                                        :
                                        <>
                                          {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                          {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                        </>
                                      :
                                      degree==="학사 과정" || degree==="석사 과정" || degree === "박사(통합) 과정"?
                                        <>
                                          {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                        </>
                                        :
                                        <>
                                          {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                          {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                        </>
                                }
                                
                            <AfterBtnForm>
                            {/* <button onClick={()=>{activateObj("null"); setTitle(); setMajor(); setPaper(); setDegree(); setProf(); setStartY(); setStartM(); setEndY(); setEndM(); setEdit()}}>취소</button> */}
                            <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                            <button onClick={()=>{activateObj("null"); fetchSchoolPost(); }}>저장</button>
                            </AfterBtnForm>
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                        )
                      } else{
                        return(
                        <div>
                          <h4>
                            {item.title}
                            {activate.school ? null : <button onClick={()=>{activateObj("school"); setEdit(item); console.log(item)}}>
                            <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                          </h4>

                          <div className={"qu-add"}>
                            {item.major}
                          </div>

                          <div className={"qu-add"}>
                            {item.degree} 
                            {item.degree === "박사(통합) 과정" || item.degree === "박사(통합) 졸업" || item.degree === "석사 과정" || item.degree === "석사 졸업"
                            ? " / " + item.prof: null}
                          </div>

                          <div className={"qu-add"}>
                            {item.start}
                            {item.end !== "undefined/undefined" 
                            && " - " + item.end}
                          </div>

                          {/* EditorState? */}
                          <div className={"ras-work-memo"}>
                            <p>{item.paper}</p>
                          </div>

                          
                        </div>
                        )}})}

                    
                  </SchoolForm>
                  : <AddBtn onClick={()=>activateObj("school")}>추가하기</AddBtn>
                }

                {activate.school && edit === undefined ? 
                  <SchoolEditForm>
                    <div className="sub-devider"></div>
                    <span>
                      <div>
                        학교이름
                        <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.title, label: edit.title}: null}
                          isSearchable={true}
                          name="color"
                          options={schoolOptions}
                          onChange={(e)=>setTitle(e.value)}
                          // onInputChange={arraySet(index, title)}
                            // setTitle(e.value)}}
                        />
                      </div>
                    </span>
                    <span>
                      <div>
                        전공
                      <CreatableSelect
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.major, label: edit.major}: null}
                          isSearchable={true}
                          name="color"
                          options={majorOptions}
                          onChange={(e)=>setMajor(e.value)}
                        />
                      </div>
                    </span>
                        
                    <span>
                      <div>
                        학위
                        <Select
                          className="profile-basic-single"
                          defaultValue={edit? {value: edit.degree, label: edit.degree}: null}
                          isSearchable={true}
                          name="color"
                          options={degreeOptions}
                          onChange={(e)=>{if(edit) {setDegree(e.value); edit.degree = e.value} else{setDegree(e.value)}}}
                        />
                      </div>
                    </span>
                        {degree === undefined && edit === undefined ? null : 
                            edit ? 
                              edit.degree==="학사 과정" || edit.degree==="학사 졸업" ?
                              null: 
                              <span>
                                <div>
                                  지도교수
                                  <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>  
                            : 
                            degree === "학사 과정" || degree === "학사 졸업" ?
                            null
                            :
                            <span>
                                <div>
                                  지도교수
                                  <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>  
                        }

                        <span>
                          <div>
                            연구주제
                          <input className="profile-basic-input" value={edit? edit.paper: paper} onChange={(e)=>{setPaper(e.target.value); if(edit) edit.paper=e.target.value}}/>
                          </div>
                        </span>

                        {
                          degree === undefined && edit === undefined ? null : 
                            edit ? 
                              edit.degree==="학사 과정" || edit.degree==="석사 과정" || edit.degree === "박사(통합) 과정" ?
                                <>
                                  {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                </>
                                :
                                <>
                                  {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                  {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                </>
                              :
                              degree==="학사 과정" || degree==="석사 과정" || degree === "박사(통합) 과정"?
                                <>
                                  {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                </>
                                :
                                <>
                                  {yearSelectorStart(setStartY, setStartM, startY, startM)}
                                  {yearSelectorEnd(setEndY, setEndM, endY, endM)}
                                </>
                        }
                        
                    <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchSchoolPost(); }}>저장</button>
                    </AfterBtnForm>
                    <div className="sub-devider"></div>
                  </SchoolEditForm>
                  :   
                <>
                  <AddBtn onClick={()=>activateObj("school")}>추가하기</AddBtn>
                </>
                // null
                }
                
              </span>

              <div className="devider"></div>

              {/* Abilities */}
              <span className={activate.abilities===false ? "deactivate": "activate"}>
                <h4>기술/도구</h4>
                <WriteEditForm>
                {abilities && abilities.length ?
                  <>

                    {abilities.map((item)=>{
                      return(
                        <div className="ras-tag">{item}</div>
                      )
                    })}
                    {activate.abilities ? null : <button onClick={()=>activateObj("abilities")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                  </>
                  : activate.abilities ? null : <button onClick={()=>activateObj("abilities")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>
                }
                </WriteEditForm>
                {activate.abilities?
                <AfterForm>
                  <CreatableSelect
                    defaultValue={handleDefault(abilities)}
                    className="profile-basic-multi"
                    isMulti
                    options={abilityOptions}
                    onChange={handleChange(setAbilities)}
                  />
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setAbilities(abilities);}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Domain */}
              <span className={activate.domain===false ? "deactivate": "activate"}>
                <h4>도메인</h4>
                <WriteEditForm>
                {domain && domain.length ?
                  <>
                    {domain.map((item)=>{
                      return(
                        <div className="ras-tag">{item}</div>
                      )
                    })}
                    {activate.domain ? null : <button onClick={()=>activateObj("domain")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                  </>
                  : activate.domain ? null : <button onClick={()=>activateObj("domain")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                  </button>
                }
                </WriteEditForm>
                
                {activate.domain?
                <AfterForm>
                  <CreatableSelect
                    defaultValue={handleDefault(domain)}
                    className="profile-basic-multi"
                    isMulti
                    options={interestOptions}
                    onChange={handleChange(setDomain)}
                  />
                  <AfterBtnForm>
                  <button onClick={()=>{activateObj("null"); setDomain(domain);}}>취소</button>
                  <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Languages */}
              <span className={activate.languages===false ? "deactivate": "activate"}>
                <h4>언어</h4>
                <WriteEditForm>
                {languages.length ?
                  <>
                    {languages.map((item)=>{
                      return(
                        <div className="ras-tag">{item}</div>
                      )
                    })}
                    {activate.languages ? null : <button onClick={()=>activateObj("languages")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                  </>
                  : activate.languages ? null : <button onClick={()=>activateObj("languages")}>
                    <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/>
                  </button>
                }
                </WriteEditForm>
                {activate.languages?
                <AfterForm>
                  <Select
                    defaultValue={handleDefault(languages)}
                    className="profile-basic-multi"
                    isMulti
                    options={languageOptions}
                    onChange={handleChange(setLanguages)}
                  />
                  <AfterBtnForm>
                  <button onClick={()=>{activateObj("null"); setLanguages(languages);}}>취소</button>
                  <button onClick={()=>{activateObj("null"); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :null
                }
              </span>

              {/* Awards */}
              <span className={activate.awards===false ? "deactivate": "activate"}>
                <h4>수상</h4>
                <WriteEditForm>
                  {singleResume && singleResume.awards ?
                    <>
                      <div className="ras-li">
                        {singleResume.awards.map((item)=>{
                          return(
                            <div>
                              {item}
                            </div>
                          )
                        })}
                      </div>
                    </>
                    : 
                    awards? 
                      <div className="ras-li">
                          {awards.map((item)=>{
                            return(
                              <div>
                                {item}
                              </div>
                            )
                          })}
                        </div>
                        :null
                  }
                  
                </WriteEditForm>
                {activate.awards?
                <AfterForm>
                  <input className="profile-basic-input" value={tempawards} onChange={(e)=>{setTempwards(e.target.value)}}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null");}}>취소</button>
                    <button onClick={()=>{activateObj("null"); handleChangeArr(setAwards, tempawards, awards); 
                    // if(resume.length) 
                      // if(singleResume.awards) 
                      //   {singleResume.awards.push(tempawards);} 
                        setTempwards(); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :
                <>
                  <AddBtn onClick={()=>activateObj("awards")}>추가하기</AddBtn>
                </>
                }
                  
              </span>

              {/* Patents */}
              <span className={activate.patents===false ? "deactivate": "activate"}>
                <h4>특허</h4>
                <WriteEditForm>
                  {/* {singleResume.patents ?
                    <>
                      <div className="ras-li">
                        {singleResume.patents.map((item)=>{
                          return(
                            <div>
                              {item}
                            </div>
                          )
                        })}
                      </div>
                    </>
                    :  */}
                    {patents? 
                      <div className="ras-li">
                          {patents.map((item)=>{
                            return(
                              <div>
                                {item}
                              </div>
                            )
                          })}
                        </div>
                        :null
                  }
                  
                </WriteEditForm>
                {activate.patents?
                <AfterForm>
                  <input className="profile-basic-input" value={temppatents} onChange={(e)=>{setTemppatents(e.target.value)}}/>
                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null");}}>취소</button>
                    <button onClick={()=>{activateObj("null"); handleChangeArr(setPatents, temppatents, patents); 
                    // if(resume.length) 
                      // if(singleResume.patents) 
                      // {singleResume.patents.push(temppatents);} 
                      setTemppatents(); fetchResumePost()}}>저장</button>
                  </AfterBtnForm>
                </AfterForm>
                :
                <>
                  <AddBtn onClick={()=>activateObj("patents")}>추가하기</AddBtn>
                </>
                }
                  
              </span>
              
              {/* Paper */}
              <span className={activate.paperPaper===false ? "deactivate": "activate"}>
                <h4>논문</h4>
                {paperPaper.length ?
                  <SchoolForm className={"ras-work"}>
                    {paperPaper.map((item, index)=>{
                      // console.log(item); 
                      if(edit === item){
                        return (
                          <SchoolEditForm>
                            <div className="sub-devider"></div>
                            <span>
                              <div>
                                제목
                                <input className="profile-basic-input" value={edit? edit.paperTitle: paperTitle} onChange={(e)=>{setPaperTitle(e.target.value); if(edit) edit.paperTitle=e.target.value}}/>
                              </div>
                            </span>
                            
                            <span>
                              <div>
                                저널
                                <input className="profile-basic-input" value={edit? edit.paperJournal: paperJournal} onChange={(e)=>{setPaperJournal(e.target.value); if(edit) edit.paperJournal=e.target.value}}/>
                              </div>
                            </span>
                                
                            <span>
                              <div>
                                저자
                                <input className="profile-basic-input" value={edit? edit.paperAuthur: paperAuthur} onChange={(e)=>{setPaperAuthur(e.target.value); if(edit) edit.paperAuthur=e.target.value}}/>
                              </div>
                            </span>
                              {/* <span>
                                <div>
                                  공저자
                                <input className="profile-basic-input" value={edit? edit.prof: prof} onChange={(e)=>{setProf(e.target.value); if(edit) edit.prof=e.target.value}}/>
                                </div>
                              </span>   */}
                              
                              
                              {/* <span>
                                <div>
                                  년도
                                <input className="profile-basic-input" value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>
                                </div>
                              </span> */}
                              
                            <span>
                              <div>
                                상태
                                <Select
                                  className="profile-basic-single"
                                  defaultValue={edit? {value: edit.status, label: edit.status}: null}
                                  isSearchable={true}
                                  name="color"
                                  options={paperOptions}
                                  onChange={(e)=>setStatus(e.value)}
                                  // onInputChange={arraySet(index, title)}
                                    // setTitle(e.value)}}
                                />
                              </div>
                            </span>
                            
                            {/* {yearSelectorStart()} */}
                            <YearWrapper>
                              <input className="profile-basic-input" style={{width: 80}} value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>년 
                            </YearWrapper>

                            <AfterBtnForm>
                              <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                              <button onClick={()=>{activateObj("null"); fetchPaperPost(); }}>저장</button>
                            </AfterBtnForm>
                              
                            <div className="sub-devider"></div>
                          </SchoolEditForm>
                        )
                      } else{
                        return(
                        <div>
                          <h4 style={{fontSize: ".9rem"}}>
                            {item.paperTitle}
                            {activate.paperPaper ? null : <button onClick={()=>{activateObj("paperPaper"); setEdit(item); console.log(item)}}>
                            <img src={"https://qurator-01.s3.ap-northeast-2.amazonaws.com/static/media/edit.png"} alt="edit"/></button>}
                          </h4>
                          <div className="qu-add"> {item.paperJournal} {item.paperAuthur} {item.paperCoAuthur} {item.paperYear} {item.status}</div>
                          <div className="ras-work-memo"></div>
                        </div>)}})}

                    {activate.paperPaper ? null :   
                    <>
                      <AddBtn onClick={()=>activateObj("paperPaper")}>추가하기</AddBtn>
                    </>
                    }
                  </SchoolForm>
                  : <AddBtn onClick={()=>activateObj("paperPaper")}>추가하기</AddBtn>
                }
                
                {activate.paperPaper && !edit?
                <SchoolEditForm>
                  <div className="sub-devider"></div>
                  <span>
                    <div>
                      제목
                      <input className="profile-basic-input" value={edit? edit.paperTitle: paperTitle} onChange={(e)=>{setPaperTitle(e.target.value); if(edit) edit.paperTitle=e.target.value}}/>
                    </div>
                  </span>
                  
                  <span>
                    <div>
                      저널
                      <input className="profile-basic-input" value={edit? edit.paperJournal: paperJournal} onChange={(e)=>{setPaperJournal(e.target.value); if(edit) edit.paperJournal=e.target.value}}/>
                    </div>
                  </span>
                      
                  <span>
                    <div>
                      저자
                      <input className="profile-basic-input" value={edit? edit.paperAuthur: paperAuthur} onChange={(e)=>{setPaperAuthur(e.target.value); if(edit) edit.paperAuthur=e.target.value}}/>
                    </div>
                  </span>
                    
                  <span>
                    <div>
                      상태
                      <Select
                        className="profile-basic-single"
                        defaultValue={edit? {value: edit.status, label: edit.status}: null}
                        isSearchable={true}
                        name="color"
                        options={paperOptions}
                        onChange={(e)=>setStatus(e.value)}
                      />
                    </div>
                  </span>
                  
                  <YearWrapper>
                    <input className="profile-basic-input" style={{width: 80}} value={edit? edit.paperYear: paperYear} onChange={(e)=>{setPaperYear(e.target.value); if(edit) edit.paperYear=e.target.value}}/>년 
                  </YearWrapper>

                  <AfterBtnForm>
                    <button onClick={()=>{activateObj("null"); setEdit()}}>취소</button>
                    <button onClick={()=>{activateObj("null"); fetchPaperPost();  }}>저장</button>
                  </AfterBtnForm>
                    
                  <div className="sub-devider"></div>
                </SchoolEditForm>
                :null
                }
              </span>
              
              <div className="devider"></div>

            </>
            }

          {/* <button onClick={()=>fetchResumePost()}>저장하기</button> */}
          </RaWrapper>
        </MidWrapper>
      </Wrapper>   
      }
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 45px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1060px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: row;
`

const RaWrapper = styled.div`
  display: flex;
  width: 100%;
  /* margin-left: 1vw; */
  min-height: 90%;
  position: relative;
  top: calc((100vh - 45px) * 0.05);
  height: auto;
  /* border: red solid; */
  background-color: rgba(255, 255, 255, 1);

  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  box-sizing: border-box;
  padding: 20px;

  border-radius: 5px;
  h3{
    :first-child{
      margin-top: 0px;
    }
    font-size: 1rem;
  }

  > span{
  /* background-color: red; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;
    
    padding-left: 10px;
    box-sizing: border-box;
    font-size: .9rem;
    h4{
      margin: 0;
      padding-top: 20px;
      padding-bottom: 20px;
      font-weight: 600;
      opacity: .6;
    }
    .profile-basic-single .profile-basic-multi{
      width: 400px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    
  }
  
  .devider{
    display: block;
    width: 100%;
    height: 1px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-top: 1px solid rgba(0,0,0,0.2);
  }
`


const ImgWrapper=styled.div`
  display: flex;
  height: 200px;
  width: 100%;

  justify-content: center;
  align-items: center;

  flex-direction: column;

  >img{
    width: 80px;
    height: 80px;
    border-radius: 50px;
  }
  >div{
    margin-top: 3px;
    margin-bottom: 3px;
    font-size: 0.8rem;
    opacity: .6;
    
  }
  .name{
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: .9rem;
    opacity: 1;
  }

`

const YearWrapper=styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  >input{
    margin-right: 5px;
    margin-left: 10px;
    :first-child{
      margin-left: 0px;
    }
  }
`

const SchoolForm=styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  
  >div{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;

    margin-bottom: 20px;

    .ras-work-memo{
      font-size: .9rem;
      margin-top: 5px;
      /* margin-bottom: 20px; */
      >p{
        white-space: pre-line;
        margin: 0;
        text-align:left;
        width: 100%;
        height: 100%;
      }
    }
    
    h4{
      font-weight: 500;
      font-size: 1.1rem;
      padding-top: 0px;
      padding-bottom: 5px;
      opacity: 1;
      position: relative;
      width: 100%;
      text-align: left;
      button{
        border: none;
        background-color: transparent;
        opacity: .4;
        transition: .2s;
        cursor: pointer;
        position: absolute;
        right: 10px;
        padding: 0px;
        :hover{
          opacity: 1;
        }
      }
    }
    
  }
`

const SchoolEditForm =styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* margin-left: 10px; */

  margin-top: 10px;
  margin-bottom: 10px;
  
  box-sizing: border-box;
  padding-right: 20px;

  width: 100%;
  >span{
    margin-bottom: 10px;
    font-size: .9rem;
    width: 100%;
    >div{
      text-align: left;
    }
  }

  .sub-devider{
    display: block;
    width: 100%;
    height: 1px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-top: 1px solid rgba(0,0,0,0.2);
  }
  
  .write-memo{
    >div{
      display: flex;
      flex-direction: column;
      >textarea{
        /* margin-top: 5px;  */
        margin-bottom: 5px;

        resize: none;
        width: 100%;
        height: 200px;
        overflow:auto;
        border: .5px solid #cccccc;
        border-radius: 4px;

      }
    }
  }

  .profile-basic-date{
    width: 100px;
  }
  .profile-basic-date-month{
    width: 70px;
  }

`

const AfterForm=styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-bottom: 5px;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding-right: 20px;

  >div{
    margin-top: 5px;
    margin-bottom: 5px;
  }
  >textarea{
    /* margin-top: 5px;  */
    margin-bottom: 5px;

    resize: none;
    width: 100%;
    height: 200px;
    overflow:auto;
    border: .5px solid #cccccc;
    border-radius: 4px;

  }
`

const WriteEditForm=styled.div`
  margin-left: 10px;

  /* height: 30px; */
  display: flex;
  width: 100%;
  position:relative;
  box-sizing: border-box;
  padding-right: 20px;

  button{
    border: none;
    background-color: transparent;
    opacity: .4;
    transition: .2s;
    height: auto;
    position: absolute;
    right: 20px;
    padding: 0px;
    cursor: pointer;
    :hover{
      opacity: 1;
    }
  }

  .ras-tag{
    display: inline-block;
    font-size: 0.9rem;
    border: .5px solid rgba(0,0,0,0.2);
    border-radius: 12px;
    padding: 5px;
    padding-left: 7px;
    padding-right: 7px;
    
    margin-right: 5px;
  }

  .ras-text{
    height: 100%;
    display: inline-flex;
    align-items: center;
    width: 100%;
    >div{
      width: 50%;
      text-align:left;
    }
  }
  .ras-li{
    display: flex;
    flex-direction: column;
    width: 100%;
    position:relative;
    >div{
      position:relative;
      display: flex;
      width: 100%;
      text-align: left;
      /* margin-top: 3px; */
      margin-bottom: 3px;
      >button{
        right: 0px;
      }
    }
  }

`


const AfterBtnForm=styled.div`
  button{
    margin-right: 10px;
    border: .5px solid rgba(253,134,18, 0.8);
    background-color: rgba(253,134,18, 0.8);
    border-radius: 5px;
    transition: .2s;
    color: white;
    box-sizing: border-box;
    padding: 5px;
    padding-right: 10px;
    padding-left: 10px;
    font-weight: 600;
    cursor: pointer;

    :hover{
      background-color: rgba(253,134,18, 1);
    }

    :first-child{
      color: rgba(0,0,0,0.6);
      border: .5px solid rgba(253,134,18, 0.8);
      background-color: white;
      :hover{
        background-color: white;
        color: black;

      }
    }
    
  }

`

const AddBtn=styled.button`
  display: flex;
  width: 100%;
  height: 40px;
  border: none;
  /* background-color: transparent; */
  background-color: rgba(0,0,0,0.1);
  justify-content: center;
  border-radius: 5px;
  align-items: center;
  cursor: pointer;
  transition: .2s;

  margin-top: 10px;
  :hover{
    background-color: rgba(0,0,0,0.2);
  }
  :focus{
    background-color: rgba(0,0,0,0.3);
  }
`
export default ResumeSingle